function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import theme from '../../theme/theme';

const Label = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Box, _extends({
  px: 1,
  py: 0.5,
  mr: 1,
  display: "flex",
  alignItems: "center",
  borderRadius: "8px",
  fontSize: theme.typography.subtitle2.fontSize,
  fontFamily: "Roboto"
}, props), children);

Label.propTypes = {
  children: PropTypes.node.isRequired
};
export default Label;